module.exports = __webpack_public_path__ + "static/3dmss_logo-943ec8f92601b0388fdcfca7d67420b0.svg";